import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.2 1.4h26c2.2 0 4 1.8 4 4v26c0 2.2-1.8 4-4 4h-26c-2.2 0-4-1.8-4-4v-26c0-2.2 1.8-4 4-4",
      "shape-rendering": "crispEdges"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m18.2 39.4-4.3-4.5h8.7z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28.9 12.7v13.9h-2.1V18H9.6v8.6H7.5V12.7l10.7-5.4zm-15 1.1H9.6V16h4.3zm-2.1 8.5H14v-2.2h-2.2zm0 4.3H14v-2.2h-2.2zm8.6-12.8H16V16h4.3v-2.2zM16 22.3h2.2v-2.2H16zm0 4.3h2.2v-2.2H16zm4.4 0h2.1v-2.2h-2.1zm6.4-12.8h-4.3V16h4.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }